import { combineReducers } from 'redux';
import authReducer from './auth';
import customizationReducer from './customizationReducer';
import settingsReducer from './settingsReducer';
import deviceReducer from './devices';
import managementReducer from './management';

const reducers = combineReducers({
    auth: authReducer,
    customization: customizationReducer,
    settings: settingsReducer,
    devices: deviceReducer,
    management: managementReducer
});
export default reducers;
